import React, { useEffect, useRef } from 'react';
import './ChatBox.css';

const ChatBox = ({ isOpen, onClose }) => {
  const chatContainerRef = useRef(null);

  useEffect(() => {
    if (isOpen && chatContainerRef.current) {
      chatContainerRef.current.innerHTML = '';

      const script = document.createElement('script');
      script.id = 'cid0020000123456789012';
      script.dataset.cfasync = 'false';
      script.async = true;
      script.src = '//st.chatango.com/js/gz/emb.js';
      script.style.width = '100%';
      script.style.height = '100%';

      const config = {
        "handle": "gtasixcountdown",
        "arch": "js",
        "styles": {
          "a": "14141e",
          "b": 100,
          "c": "ffffff",
          "d": "050505",
          "k": "ffffff",
          "l": "ff5cc2",
          "m": "4b5bff",
          "n": "ff5cc2",
          "p": "10",
          "q": "4b5bff",
          "r": 100,
          "f": "050505"
        }
      };

      script.textContent = JSON.stringify(config);
      chatContainerRef.current.appendChild(script);
    }
  }, [isOpen]);

  return (
    <div className={`chat-sidebar ${isOpen ? 'open' : ''}`}>
      <div className="chat-header">
        <h2>Live Chat</h2>
      </div>
      <div className="chat-container" ref={chatContainerRef}>
        {!isOpen && <div className="chat-placeholder">Loading chat...</div>}
      </div>
    </div>
  );
};

export default ChatBox;
